import React, { Component } from "react";
import PropTypes from "prop-types";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";
import { CircularProgress, Button } from "@material-ui/core";
import routes from "../../boot/routeConfig";
import { ReportUrl } from '../../services/reportUrl';

@CSSModules(styles, { allowMultiple: true })
class Auth extends Component {
   static defaultProps = {
      onlyAllowIfLoggedIn: false,
      navToLoginIfUnAuthed: true,
      isRoute: false //lookup routes data to determine auth
   };
   static propTypes = {
      isRoute: PropTypes.bool,
      onlyAllowIfLoggedIn: PropTypes.bool,
      navToLoginIfUnAuthed: PropTypes.bool
   };

   shouldComponentUpdate(nextProps, nextState) {
       if (ReportUrl.isReportUrlWithDate(nextProps.route) &&
           ReportUrl.isReportUrlWithDate(this.props.route) &&
           this.props.loaded) {
           // stops the report page rerendering each time the date is changed in the url
           return false;
       }
       return true;
   }
   
   render() {
      if (!this.props.loaded) {
         return (
            <div styleName="content">
               <CircularProgress />
            </div>
         );
      }
      let { onlyAllowIfLoggedIn } = this.props;

      if (this.props.isRoute) {
         const current = routes.find(x => {
            let path = x.path;
            if (path.includes(":")) {
               const index = path.indexOf(":");
               path = path.substr(0, index);
               return this.props.route.substr(0, index) === path;
            } else {
               return path === this.props.route;
            }
         });
         if (current) {
            onlyAllowIfLoggedIn = current.authorise;
         }
      }

      let isAuthed = true;
      if (onlyAllowIfLoggedIn && !this.props.isLoggedIn) {
         isAuthed = false;
      }

      if (isAuthed || this.props.route === "/Login") {
         return this.props.children;
      } else {
         if (this.props.navToLoginIfUnAuthed) {
            console.warn("Unauthorized. Nav to login");
            setTimeout(() => {
					this.props.navigate("/Login");
				});
         } else {
            console.warn("Unauthorized.");
            return (
               <div styleName="content">
                  403 Unauthorized
                  <Button
                     onClick={() => {
                        this.props.navigate("/Login");
                     }}
                  >
                     Login
                  </Button>
               </div>
            );
         }
      }
   }
}

const bindAction = dispatch => {
   return {
      navigate: (uri, data) => dispatch(router.push(uri, data)),
      goBack: () => dispatch(router.goBack())
   };
};

const mapStateToProps = state => ({
   route: state.router.location.pathname,
   isLoggedIn: state.login.isLoggedIn,
   loaded: state.login.loaded
});

export default connect(
   mapStateToProps,
   bindAction
)(Auth);



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js